import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const InvSlide03Solution: React.FC = () => {
  const objectives = [
    {
      goal: 'Understand the syllabus',
      solution: 'Track exactly where kids are against the NSW curriculum',
    },
    {
      goal: 'No wasted homework time',
      solution: 'System targets specific areas they\'re struggling with',
    },
    {
      goal: 'Adaptive difficulty',
      solution: 'Concepts learned at the right level - not too easy, not too hard',
    },
    {
      goal: 'Real-time visibility',
      solution: 'Parents and teachers see progress instantly, not quarterly',
    },
    {
      goal: 'Engaged students',
      solution: 'Gamification that makes kids want to learn',
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-4 text-center"
      >
        What We Set Out to Solve
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-2xl text-[#94a3b8] mb-12 text-center max-w-3xl"
      >
        A platform that gives parents visibility, teachers control, and students an engaging learning experience
      </motion.p>

      <div className="w-full max-w-4xl">
        {objectives.map((item, index) => (
          <motion.div
            key={item.goal}
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
            className="flex items-center gap-6 mb-5"
          >
            <div className="flex items-center gap-4 w-[280px]">
              <CheckCircleIcon className="w-7 h-7 text-[#10b981] flex-shrink-0" />
              <span className="text-xl text-white font-medium">{item.goal}</span>
            </div>
            <div className="text-3xl text-[#334155]">→</div>
            <div
              className="flex-1 px-6 py-4 rounded-xl text-lg text-[#94a3b8]"
              style={{
                background: 'rgba(16, 185, 129, 0.1)',
                border: '1px solid rgba(16, 185, 129, 0.3)',
              }}
            >
              {item.solution}
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.9 }}
        className="mt-12 px-8 py-5 rounded-2xl text-center"
        style={{
          background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.2) 0%, rgba(6, 182, 212, 0.2) 100%)',
          border: '2px solid rgba(14, 165, 233, 0.4)',
        }}
      >
        <p className="text-2xl text-white font-medium">
          The result: <span className="text-[#0ea5e9]">Lumen8</span> — Duolingo meets the Australian curriculum
        </p>
      </motion.div>
    </div>
  );
};

export default InvSlide03Solution;
